import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function SocialProofSection() {
  const stats = [{
    value: '150+',
    label: 'Firmas de abogados atendidas'
  }, {
    value: '3x',
    label: 'Más casos calificados en 90 días'
  }, {
    value: '$2M+',
    label: 'En casos generados para nuestros clientes'
  }, {
    value: '97%',
    label: 'Tasa de satisfacción'
  }];
  const testimonials = [{
    quote: 'Antes dependía solo de referidos. En 3 meses, el sistema me trajo 12 casos nuevos de inmigración con retainer pagado.',
    author: 'Lic. María González',
    role: 'Abogada de Inmigración, Houston TX',
    initials: 'MG'
  }, {
    quote: 'Dejé de perder tiempo en consultas gratis. Ahora solo hablo con clientes que ya están listos para contratar.',
    author: 'Lic. Roberto Méndez',
    role: 'Abogado de Accidentes, Los Angeles CA',
    initials: 'RM'
  }, {
    quote: 'Mi firma pasó de 3 casos al mes a 11 casos calificados. El ROI fue inmediato.',
    author: 'Lic. Ana Castillo',
    role: 'Abogada de Familia, Miami FL',
    initials: 'AC'
  }];
  const badges = ['Google Partner', 'Meta Business Partner', '100% Enfocados en el Nicho Legal'];
  return <section className="py-20 sm:py-24 px-4 sm:px-6 lg:px-8 bg-[#0a0a0a] border-t border-white/5 relative" data-id="element-202">
      <div className="max-w-7xl mx-auto" data-id="element-203">
        {/* Stats Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-20" data-id="element-204">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center" data-id="element-205">
              <div className="font-heading text-4xl sm:text-5xl font-bold text-gold mb-2" data-id="element-206">
                {stat.value}
              </div>
              <div className="font-body text-sm sm:text-base text-gray-400" data-id="element-207">
                {stat.label}
              </div>
            </motion.div>)}
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mb-16" data-id="element-208">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2 + index * 0.1
        }} className="bg-[#111] border border-white/5 rounded-2xl p-6 sm:p-8 flex flex-col h-full relative" data-id="element-209">
              <QuoteIcon className="absolute top-6 right-6 w-8 h-8 text-white/5" data-id="element-210" />
              <div className="flex gap-1 mb-6" data-id="element-211">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-212" />)}
              </div>
              <p className="font-body text-gray-300 text-base sm:text-lg leading-relaxed mb-8 flex-grow italic" data-id="element-213">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-214">
                <div className="w-12 h-12 rounded-full bg-gold/20 border border-gold/30 flex items-center justify-center flex-shrink-0" data-id="element-215">
                  <span className="font-heading font-bold text-gold" data-id="element-216">
                    {testimonial.initials}
                  </span>
                </div>
                <div data-id="element-217">
                  <div className="font-heading font-semibold text-white" data-id="element-218">
                    {testimonial.author}
                  </div>
                  <div className="font-body text-sm text-gray-400" data-id="element-219">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Trust Badges */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="flex flex-wrap justify-center items-center gap-6 sm:gap-12 pt-8 border-t border-white/5" data-id="element-220">
          {badges.map((badge, index) => <div key={index} className="font-heading text-sm sm:text-base font-semibold text-gray-500 uppercase tracking-widest text-center" data-id="element-221">
              {badge}
            </div>)}
        </motion.div>
      </div>
    </section>;
}